

const pageInfo = {
    english:{
        name:"Juan David Ramirez V.",
        short_introduction:"Fullstack engineer, developer, and tech hobbyist specialized in backend with self learning habits and leadership capabilities. More than five years of experience and direct responsibility for successfully launching end to end applications for international clients including 60hertz, Dave, Instride.",
        
        issues_link:"https://github.com/juanda2222/personal_brand",

        github_link:"https://github.com/juanda2222",
        behance_link:"https://www.behance.net/juandaramirez3",
        linkedin_link:"https://www.linkedin.com/in/juandara2222/",

        facebook_link:"https://www.facebook.com/juandavid.ramirezvillegas.5",
        instagram_link:"https://www.instagram.com/juanda_ra/",
        twitter_link:"https://twitter.com/JuanDav80657184",
        projects_text: "The projects published here are either personal or the result of a client’s request. To contact the team please refer directly to the GitHub team.",
        about_me:"I am a Colombian engineer with great passion for programing. I like to give all my heart at everything i do. My hobbies are playing the guitar, dancing, and jogging.",
        Download_resumee_text: "Download Resumee",
        contact_me_text1: "Text me through social media",
        contact_me_text2: "Send me an email",

        resumee_file_url:"https://drive.google.com/file/d/1LnZjLj1gRYgkSyW0eQRepbN4tF-9EfzH/view?usp=sharing",
    }
    
}
export default pageInfo


